module.exports = __webpack_public_path__ + "img/Add.15b743dc.svg";